"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTempMasseyFonts = void 0;
var utils_1 = require("./utils");
var getTempMasseyFonts = function (isNativeIOS) { return ({
    primary: {
        bold: (0, utils_1.getFontStyles)('"Helvetica Neue LT W1G 77 Bold Condensed"', isNativeIOS, true),
        regular: (0, utils_1.getFontStyles)('"Helvetica Neue LT Std 55 Roman"', isNativeIOS),
    },
    secondary: {
        bold: (0, utils_1.getFontStyles)('"Arial Narrow Bold"', isNativeIOS, true),
        regular: (0, utils_1.getFontStyles)('"Arial Narrow"', isNativeIOS),
    },
}); };
exports.getTempMasseyFonts = getTempMasseyFonts;
